module.exports = __webpack_public_path__ + "img/gym-soleil.bf57bfab.svg";